module.exports = __webpack_public_path__ + "static/media/what-is-a-decision-aid.d642ffa9.svg";